<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .subscribe-modal__plan(:class="theClass" @click="select" :disabled="disabled")
            .subscribe-modal__plan-row
                .subscribe-modal__plan-info
                    .subscribe-modal__plan-title {{ product.title }}
                        .subscribe-modal__plan-deleted-text(v-if="!product.is_active")  (deleted)
                    .subscribe-modal__plan-title(v-if="plan.display_name") {{ plan.display_name }}
                        .subscribe-modal__plan-deleted-text(v-if="product.is_active && !plan.is_active")  (deleted)
                    .subscribe-modal__plan-description(v-if="screenSM && plan.description") {{ plan.description }}
                .subscribe-modal__plan-price-info
                    span.subscribe-modal__plan-price {{ plan.amount | currency }}
                    span.subscribe-modal__plan-loop /{{ interval }}
                    re-button.re-button--sm.re-button--secondary(v-if="cancellable" @click="cancel" :loading="cancelingSubscription") Cancel
                    .subscribe-modal__plan-expire(v-if="subscription && subscription.status == 'cancelling'") Expires on {{ endsAt }}
            .subscribe-modal__plan-description(v-if="!screenSM && plan.description") {{ plan.description }}
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import moment from 'moment'

export default {
    name: 'subscribe-modal-plan',

    components: {
        MatchMedia,
    },

    props: {
        product: {
            type: Object,
            required: true
        },
        plan: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            required: true,
        },
        subscription: {
            type: Object | undefined,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },

    data() { return {
        cancelingSubscription: false,
    }},

    computed: {
        interval() {
            return (this.plan.period > 1 ? this.plan.period : '') + this.plan.interval.charAt(0).toUpperCase() + this.plan.interval.slice(1)
        },

        theClass() {
            return {
                'subscribe-modal__plan--active': this.selected,
                'subscribe-modal__plan--subscribed': !!this.subscription,
            }
        },

        endsAt() {
            return moment(this.subscription.ends_at).format('D MMMM, YYYY')
        },

        cancellable() {
            return this.subscription && window.addiesaas.subscriptions.statuses.cancellable.includes(this.subscription.status)
        },
    },

    methods: {
        select() {
            if (!this.disabled) {
                this.$emit('select')
            }
        },

        cancel() {
            if (this.cancellable) {
                this.cancelingSubscription = true
                this.$emit('cancel')
            }
        },
    },
}
</script>
